module.exports = __webpack_public_path__ + "img/xlph3.67f085a7.jpg";